<template>
  <div class="flex flex-col space-y-2">
    <div
      class="rounded-full px-3 py-1 text-xs font-medium tracking-wide"
      :class="[
        {
          'text-red-600': rejected,
          'bg-red-100 bg-opacity-75': rejected,
          'text-green-600': !pending && !rejected,
          'bg-green-100 bg-opacity-75': !pending && !rejected,
          'text-white': !rejected && pending,
          'bg-black bg-opacity-75': !rejected && pending,
        },
      ]"
    >
      <template v-if="rejected"> Rejected </template>
      <template v-else-if="pending"> In Review </template>
      <template v-else-if="approved"> Approved </template>
    </div>

    <div
      v-if="claims"
      class="rounded-full px-3 py-1 text-xs font-medium tracking-wide text-gray-900 bg-white border border-black"
    >
      {{ claims }} Claims
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectAssetTileApprovalStatus',
  props: {
    claims: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    pending: { type: Number, default: 0 },
    approved: { type: Number, default: 0 },
    rejected: { type: Number, default: 0 },
  },
};
</script>
